import { render, staticRenderFns } from "./ListCategory.vue?vue&type=template&id=2dc5397a&scoped=true"
import script from "./ListCategory.vue?vue&type=script&lang=js"
export * from "./ListCategory.vue?vue&type=script&lang=js"
import style0 from "./ListCategory.vue?vue&type=style&index=0&id=2dc5397a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc5397a",
  null
  
)

export default component.exports